module.exports = __webpack_public_path__ + "static/img/face_1.59f36431.webp";